module.exports = __webpack_public_path__ + "media/images/add-new-image-4a8c07900d9196ef38ef503241c278f7.png";